@if (this.loadingSrv.isLoading | async) {
<div class="spinner-container">
  <div class="row">
    <div class="spinner-border text-secondary-yellow" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
  </div>
</div>
}
